export class Form {
    element;
    #formSelectInstanceList;

    constructor({element}) {
        this.element = element;
        this.main();
    }

    main() {
        this.setupSelectElements();
        this.setupScroll();
        this.setupTextareaHeight();
    }

    handleScrollTrigger(event) {
        event.preventDefault();
        this.scrollToForm(event.currentTarget);
        this.setSelectElementValue(event.currentTarget);
    }

    setupTextareaHeight() {
        const textArea = this.element.querySelector('textarea');
        const selectSubject = [...this.element.querySelectorAll('select')].find(e => e.classList.contains('select-subject'));

        const handleTextAreaHeight = () => {
            setTimeout(() => {
                const selectPackage = [...this.element.querySelectorAll('select')].find(e => e.classList.contains('select-package'));
                if (typeof selectPackage === 'undefined') {
                    textArea.style.height = '272px';
                } else {
                    textArea.style.height = '215px';
                }
            }, 0);
        }
        selectSubject.addEventListener('change', handleTextAreaHeight);
        handleTextAreaHeight();
    }

    scrollToForm(target) {
        const scrollTargetId = target.dataset.formTarget;
        const scrollElementTarget = document.getElementById(scrollTargetId);
        scrollElementTarget.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
        });
    }

    setSelectElementValue(target) {
        const setSelectPackage = value => {
            const selectPackage = [...this.element.querySelectorAll('select')].find(e => e.classList.contains('select-package'));
            if (selectTheme !== undefined) {
                selectPackage.value = value;
            }
        }
        const selectTheme = this.formSelectInstanceList.find(e => e.classList.contains('select-subject'));
        if (selectTheme !== undefined) {
            selectTheme.value = 'paketo-gaiasense';
            setTimeout(() => {
                selectTheme.dispatchEvent(new Event("change", {
                    bubbles: true,
                    cancelable: true
                }));
                setSelectPackage(target.dataset.selectValue)
            }, 0);
        }
    }

    setupScroll() {
        for (const scrollNavElement of document.querySelectorAll('[data-form-target]')) {
            scrollNavElement.addEventListener('click', (event) => this.handleScrollTrigger(event), false);
        }
    }

    setupSelectElements() {
        this.formSelectInstanceList = [...this.element.querySelectorAll('select')];
    }

    get formSelectInstanceList() {
        return this.#formSelectInstanceList;
    }

    set formSelectInstanceList(value) {
        this.#formSelectInstanceList = value;
    }
}
